import { DialogContent } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useUpdateByPk } from "../../../apollo/networking/use-update-by-pk";
import { useAppDialog } from "../../../app-dialog";
import { DiplomaFragment, DiplomaModel } from "../../../models/diploma.model";
import { BasicDialogActions } from "../../../ui/dialog";
import { LoadingButton } from "../../../ui/loading-button";
import { DiplomaForm } from "./diploma.form";
import { DiplomaInitialValues, DiplomaValidationSchema, validateDiploma } from "./diploma.validation";


type Props = {
    item: DiplomaModel;
    onFinish: (product: DiplomaModel) => void;
}

export const DiplomaEdit = ({
    onFinish,
    item,
}: Props) => {
    const {
        onUpdate,
        loading,
    } = useUpdateByPk({
        entity_name: 'diploma',
        pk_columns: [{
            name: 'id',
            type: 'bigint',
            value: item.id,
        }],
        fragment: DiplomaFragment,
    });

    const app_dialog = useAppDialog();

    const onSubmit = async (values: any) => {
        try {
            const result = await onUpdate({
                ...validateDiploma(values),
            }) as DiplomaModel;
            if (!!result) {
                onFinish(result);
            }
        } catch (e: any) {
            app_dialog.showError(e);
        }
    }
    return <Formik initialValues={DiplomaInitialValues(item)}
        validationSchema={DiplomaValidationSchema}
        onSubmit={onSubmit}>{() => <Form noValidate>
            <DialogContent>
                <DiplomaForm />
            </DialogContent>
            <BasicDialogActions>
                <LoadingButton loading={loading}
                    color='primary'
                    size='large'
                    type='submit'
                    variant='contained'>
                    Save
                </LoadingButton>
            </BasicDialogActions>
        </Form>}
    </Formik>
}
